import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import moment from "moment"

import { get } from "library/endpoints"
import { Divider } from "antd"

const List = (props) => {
  const [entries, setEntries] = useState([])

  useEffect(() => {
    fetchData();
  }, [])

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/help-desk`)
      setEntries(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  console.log(entries);

  return (
    <>
      <Divider>Mes tickets</Divider>
      
      {
        entries.map((entry) => (
          <div>
            Ticket du {moment(entry.created_at).format('DD/MM/YYYY')}
          </div>
        ))
      }
    </>
  )
}

export default withTranslation()(List)